import { render, staticRenderFns } from "./TagMetadata.vue?vue&type=template&id=535b1268&"
import script from "./TagMetadata.vue?vue&type=script&lang=js&"
export * from "./TagMetadata.vue?vue&type=script&lang=js&"
import style0 from "./TagMetadata.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports